import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { SERVICES } from '../data/services';
import { SERVICE_ICONS } from './serviceIcons';
import { ArrowRight } from 'lucide-react';

export const ServicesSection = () => {
  return (
    <section id="services" className="py-20 bg-white scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Dispatch Services</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Dedicated dispatch and back-office support for every equipment type, plus the compliance
            services owner operators and fleets need to grow.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {SERVICES.map((service) => {
            const Icon = SERVICE_ICONS[service.icon];
            return (
              <Link
                key={service.slug}
                to={`/services/${service.slug}`}
                className="group block"
                data-testid={`home-service-card-${service.slug}`}
              >
                <Card className="h-full hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-gray-100 hover:border-blue-200">
                  <CardContent className="pt-6">
                    <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-orange-100 transition-colors">
                      {Icon && <Icon className="h-7 w-7 text-blue-600 group-hover:text-orange-600 transition-colors" />}
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{service.shortName}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-2">{service.hero.sub}</p>
                    <span className="inline-flex items-center gap-1 text-orange-600 font-semibold text-sm group-hover:gap-2 transition-all">
                      Learn More <ArrowRight className="h-4 w-4" />
                    </span>
                  </CardContent>
                </Card>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
